import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.feature-sets.CreditCardAccountDetailsView`

export default defineMessages({
  activeTabLabel: {
    id: `${scope}.activeTabLabel`,
    defaultMessage: 'Active credit card items',
  },
  archivedTabLabel: {
    id: `${scope}.archivedTabLabel`,
    defaultMessage: 'Archived credit card items',
  },
  addItemButton: {
    id: `${scope}.addItemButton`,
    defaultMessage: 'Add a new item',
  },
  moveItemsButton: {
    id: `${scope}.moveItemsButton`,
    defaultMessage: 'Move items',
  },
  cancelMoveModeButton: {
    id: `${scope}.cancelMoveModeButton`,
    defaultMessage: 'Cancel',
  },
  editItemMenuItem: {
    id: `${scope}.editItemMenuItem`,
    defaultMessage: 'Edit item',
  },
  archiveItemMenuItem: {
    id: `${scope}.archiveItemMenuItem`,
    defaultMessage: 'Archive item',
  },
  unarchiveItemMenuItem: {
    id: `${scope}.unarchiveItemMenuItem`,
    defaultMessage: 'Unarchive item',
  },
  createItemModalTitle: {
    id: `${scope}.createItemModalTitle`,
    defaultMessage: 'Create credit card item',
  },
  editItemModalTitle: {
    id: `${scope}.editItemModalTitle`,
    defaultMessage: 'Edit credit card item',
  },
  reconcileModalTitle: {
    id: `${scope}.reconcileModalTitle`,
    defaultMessage: 'Reconcile account',
  },
  moveWarningModalTitle: {
    id: `${scope}.moveWarningModalTitle`,
    defaultMessage: 'Move credit card items',
  },
  moveWarningDismissButton: {
    id: `${scope}.moveWarningDismissButton`,
    defaultMessage: 'Dismiss',
  },
  moveWarningConfirmButton: {
    id: `${scope}.moveWarningConfirmButton`,
    defaultMessage: 'Move',
  },
  // Exact Angular parity title (BHV-007).
  sessionLockedToastTitle: {
    id: `${scope}.sessionLockedToastTitle`,
    defaultMessage: 'Session Locked',
  },
  sessionLockedToastMessage: {
    id: `${scope}.sessionLockedToastMessage`,
    defaultMessage: '{name} is in the process of reconciling this account.',
  },
})
